import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';

import Loader from '../../../components/Loader/Loader';
import PopularLocationManagement from '../../../components/siteadmin/PopularLocation/PopularLocationManagement';

import getPopularLocation from './getPopularLocation.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './PopularLocation.css';

class PopularLocation extends React.Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool,
            getPopularLocation: PropTypes.array,
        })
    };

    static defaultProps = {
        data: {
            loading: true
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1
        }
    }

    setStateVariable = (variables) => {
        this.setState(variables);
    }

    render() {
        const { data: { getPopularLocation, refetch, loading } } = this.props;
        const { currentPage } = this.state;
        return (
            <div>
                {loading && <div><Loader type={"text"} /></div>}
                {!loading && <PopularLocationManagement
                    data={getPopularLocation}
                    refetch={refetch}
                    setStateVariable={this.setStateVariable}
                    currentPage={currentPage}
                />}
            </div>
        );
    }
}

export default compose(
    withStyles(s),
    withQuery(getPopularLocation,
        {
            options: (props) => ({
                variables: {
                    currentPage: 1,
                    searchList: '',
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }),
)(PopularLocation);